import React from 'react';
import styled from 'styled-components';
import Text from 'components/Text';
import { COLOR } from 'config';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import image from '../images/FB-Landing-Page-graphic4.png';
import Title from './Title';
import Card from './Card';
import Button from './Button';
import { ImageGraphicCardContainer } from './ImageCard';

const StyledText = styled(Text)`
  line-height:2.35rem;
`;

const StyledButton = styled(Button)`
  //color:${COLOR.white};
  background-color:${COLOR.base};
  border-radius:5px;
  padding: 12px 24px;
  padding-bottom: 13px;
  margin-top: 14px;
  color: white;
  line-height: 1 !important;
  font-weight: bold;
  &:hover{
    background-color:${COLOR.base};
  }
`;

const InstallWallet = () => {
  const icon = (<ImageGraphicCardContainer
    image={image}
    height="400"
    width="480"
    backgroundColor={COLOR.base}
    backgroundSize={'400px'}
    backgroundImageOnBottom
  />);

  return (
    <Card image={icon} mb={'0rem'} flexDirection="row-reverse">
      <Title id="Installing the Skycoin wallet" />
      <StyledText>
        <FormattedHTMLMessage id="To receive your crypto gift, you will need to install the Skycoin wallet. The Skycoin wallet is available for desktop or mobile operating systems and is free, secure and easy to install. The intuitive user interface makes transacting in Skycoin a breeze." />
      </StyledText>
      <StyledButton to="https://www.skycoin.com/downloads/" width={['100%', 'auto', 'auto']}>
        <FormattedMessage id="Download the Skywallet" />
      </StyledButton>
    </Card>
  );
};

export default InstallWallet;



// WEBPACK FOOTER //
// ./src/components/NYCMeetUpLanding/components/InstallWallet.js